require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-a-new-era-for-rla.json") })
        }
      }, "path---authors-a-new-era-for-rla");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-a-new-era-for-rla!./.cache/json/authors-a-new-era-for-rla.json
// module id = 1248
// module chunks = 231608221292675